// ── 設定相關 API ─────────────────────────────────────────────────────────────

import { apiFetch, API_BASE_URL } from './client';
import type { Settings } from '../../types';

export const fetchSettings = async (): Promise<Settings> => {
  const res = await apiFetch(`${API_BASE_URL}/db/settings`);
  if (!res.ok) throw new Error('Failed to fetch settings');
  return res.json();
};

export const updateSettings = async (settings: Partial<Settings>): Promise<Settings> => {
  const res = await apiFetch(`${API_BASE_URL}/db/settings`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (!res.ok) throw new Error('Failed to update settings');
  return res.json();
};

export const updateSettingsWithImage = async (settings: Partial<Settings>, imageFile?: File): Promise<Settings> => {
  const formData = new FormData();
  // organizationName / title 允許清空（顯式空字串）；用 in 判斷而非 truthy
  if ('organizationName' in settings) formData.append('organizationName', settings.organizationName ?? '');
  if (settings.organizationType) formData.append('organizationType', settings.organizationType);
  if (settings.name) formData.append('name', settings.name);
  if ('title' in settings) formData.append('title', settings.title ?? '');
  if (imageFile) formData.append('profileImage', imageFile);

  const res = await apiFetch(`${API_BASE_URL}/db/settings`, { method: 'PUT', body: formData });
  if (!res.ok) throw new Error('Failed to update settings with image');
  return res.json();
};
